// Thin wrapper for PouchDB to allow simple mocking or replacing with
// pouchdb-memory.

import PouchDB from 'pouchdb';
import pouchFind from 'pouchdb-find';
import { couchBaseURL } from './backend-api';

// PouchDB plugins
PouchDB.plugin(pouchFind);

const pouch = {
  PouchDB,
  createLocalDB(couchName, options) {
    return new pouch.PouchDB(couchName, options);
  },
  createRemoteDB(couchName, options) {
    return new pouch.PouchDB(couchBaseURL + couchName, options);
  },
  setupSync(localDB, remoteDB) {
    const syncStatus = {
      uploadActivity: remoteDB ? 'idle' : 'offline',
      downloadActivity: remoteDB ? 'idle' : 'offline',
    };
    Object.defineProperty(syncStatus, 'activity', {
      get() {
        if (syncStatus.uploadActivity == 'offline' ||
          syncStatus.downloadActivity == 'offline') {
          return 'offline';
        }
        if (syncStatus.uploadActivity == 'push') {
          return 'push';
        }
        if (syncStatus.downloadActivity == 'fetch') {
          return 'fetch';
        }
        return 'idle';
      },
    });
    if (remoteDB) {
      // Unfortunately database.sync() doesn't give granular enough callbacks,
      // so we need to set up both sides of the replication separately.
      // Relevant issue: https://github.com/pouchdb/pouchdb/issues/6959
      localDB.replicate.from(remoteDB, {
        live: true,
        retry: true,
        // Heartbeats can't make it through our stack at the moment, so we use
        // the timeout instead.
        heartbeat: false,
        timeout: 60000, // 1 minute. This is the default maximum for CouchDB.
      }).on('paused', (err) => {
        if (err) {
          syncStatus.downloadActivity = 'offline';
        } else {
          syncStatus.downloadActivity = 'idle';
        }
      }).on('active', (info) => {
        syncStatus.downloadActivity = 'fetch';
      }).on('error denied', (err) => {
        syncStatus.downloadActivity = 'offline';
        // TODO: surface it better.
        console.error('database sync error (fetch):', err);
      });
      const replicationOpts = { live: true, retry: true }
      // keep docs representing calendar events local, except on localhost
      // (where replicating them helps in debugging)
      if (window.location.hostname.toLowerCase() != 'localhost') {
        replicationOpts.filter = function (doc) {
          return !doc._id.startsWith('gcal:');
        }
      }
      localDB.replicate.to(remoteDB, replicationOpts).on('paused', (err) => {
        if (err) {
          syncStatus.uploadActivity = 'offline';
        } else {
          syncStatus.uploadActivity = 'idle';
        }
      }).on('active', (info) => {
        syncStatus.uploadActivity = 'push';
      }).on('error denied', (err) => {
        syncStatus.uploadActivity = 'offline';
        // TODO: surface it better.
        console.error('database sync error (push):', err);
      });
    }
    return syncStatus;
  }
};

export default pouch;
